/* istanbul ignore file */
import { Show } from 'framework/show';
import React from 'react';
import { useProjectId, useProjectService } from 'domain/shared/project';

const ShowProject = ({ children = null }: { children?: React.ReactNode }) => {
  const { getById } = useProjectService();
  const currentProjectId = useProjectId();

  return <Show getDataMethod={() => getById(currentProjectId)}>{children}</Show>;
};

export default ShowProject;
